module.exports = __webpack_public_path__ + "img/dream3.b1718652.png";